import { origenPublico } from './origenPublico';
export const clavePedidoValida = valor => typeof valor === 'string' && /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(valor);
export const enlaceSeguimientoPedido = (gymId, clave) => {
  if (!/^[a-z0-9]{1,100}$/.test(gymId) || !clavePedidoValida(clave)) return '';
  // Fragmento privado: no viaja al Hosting ni al encabezado Referer.
  return `${origenPublico()}/seguimiento/${gymId}#${clave}`;
};
